import { useState } from "react";
import { MentorshipPlanTopicTransformed } from "../../mentorship-curriculum/types/mentorship-plan";
import {
  collapsedAllTopicsClicked,
  expandAllTopicsClicked,
  topicsExpanded,
} from "../../mentorship-curriculum/analytics/index.analytics";

type UseTopicsProps = {
  defaultAnalyticsPayload: any;
  groupMentorTopicsBySubject: Record<string, MentorshipPlanTopicTransformed[]>;
};

const useTopics = ({
  defaultAnalyticsPayload,
  groupMentorTopicsBySubject,
}: UseTopicsProps) => {
  const listOfSubjects = Object.keys(groupMentorTopicsBySubject);
  const [expandTopics, setExpandTopics] = useState<string[]>([]);

  const toggleExpandTopics = (subjects: string[], expandAll?: boolean) => {
    setExpandTopics((prev) => {
      if (expandAll === true) {
        // Add all subjects (no duplicates)
        return Array.from(new Set(prev.concat(subjects)));
      }

      if (expandAll === false) {
        // Remove all subjects
        return prev.filter((topic) => !subjects.includes(topic));
      }

      // Toggle each subject individually
      return subjects.reduce((acc, subject) => {
        return acc.includes(subject)
          ? acc.filter((item) => item !== subject)
          : acc.concat(subject);
      }, prev);
    });
    if (expandAll === true) {
      expandAllTopicsClicked(defaultAnalyticsPayload);
    } else if (expandAll === false) {
      collapsedAllTopicsClicked(defaultAnalyticsPayload);
    } else {
      topicsExpanded({
        subjects,
        ...defaultAnalyticsPayload,
      });
    }
  };

  return { listOfSubjects, expandTopics, toggleExpandTopics };
};

export default useTopics;
